module.exports = __webpack_public_path__ + "img/parter-logo-6.cde746c7.jpg";